/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconRadarDish: {
  name: 'radar_dish';
  data: string;
} = {
  name: 'radar_dish',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M274.18 19.217 274.182 19.221 274.183 19.22z"/><path d="M583.628 154.513c-10.336-17.918-33.244-24.048-51.16-13.695-13.498 7.8-20.313 22.734-18.435 37.288l-126.099 38.315-113.752-197.2c-66.454 62.901-98.128 154.146-85.841 243.147l-42.823 7.534 12.763 72.387-50.272 47.046 22.339 38.395 70.133-21.27 8.978 11.814L73.26 588.396h303.236l-20.031-108.07c59.065 24.606 126.115 28.855 189.443 9.959l-113.75-197.198 96.172-90.115c11.659 8.964 28.033 10.554 41.568 2.733 17.92-10.355 24.066-33.274 13.73-51.192z"/></svg>`,
};
